import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--email" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl p-mypage__ttl--complete c-ttl" }, "メールアドレス 更新完了", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "p-mypage__txt" }, "メールアドレスを更新しました。", -1)
const _hoisted_5 = { class: "p-mypage__btn" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "マイページに戻る", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: { name: 'MypageTop' },
          class: "c-btn c-btn--outline"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}